import { render, staticRenderFns } from "./AcompanhamentoConfiguracaoSensor.vue?vue&type=template&id=5139e71a&scoped=true&"
import script from "./AcompanhamentoConfiguracaoSensor.vue?vue&type=script&lang=js&"
export * from "./AcompanhamentoConfiguracaoSensor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5139e71a",
  null
  
)

export default component.exports